import React from 'react';
import { Route, Switch } from 'react-router-dom';
import LoadableVisibility from 'react-loadable-visibility/react-loadable';
import routes from './routes';

export const Loading = ({ height }) => {
    return <div style={{ height: `${height || '100vh'}` }}> </div>;
};

//import ActivityPage from '../ActivityPage';
const ActivityPage = LoadableVisibility({
    loader: () => import('../ActivityPage'),
    loading: Loading,
});
//import ActivityReviewsPage from '../ActivityReviewsPage';
const ActivityReviewsPage = LoadableVisibility({
    loader: () => import('../ActivityReviewsPage'),
    loading: Loading,
});
//import AttractionsPage from '../AttractionsPage';
const AttractionsPage = LoadableVisibility({
    loader: () => import('../AttractionsPage'),
    loading: Loading,
});
//import BlogPostPage from '../BlogPostPage';
const BlogPostPage = LoadableVisibility({
    loader: () => import('../BlogPostPage'),
    loading: Loading,
});
//import BlogsDestinationPage from '../BlogsDestinationPage';
const BlogsDestinationPage = LoadableVisibility({
    loader: () => import('../BlogsDestinationPage'),
    loading: Loading,
});
//import BlogsPage from '../BlogsPage';
const BlogsPage = LoadableVisibility({
    loader: () => import('../BlogsPage'),
    loading: Loading,
});
//import CartPage from '../CartPage';
const CartPage = LoadableVisibility({
    loader: () => import('../CartPage'),
    loading: Loading,
});
//import CheckoutPage from '../CheckoutPage';
const CheckoutPage = LoadableVisibility({
    loader: () => import('../CheckoutPage'),
    loading: Loading,
});
//import ContentPage from '../ContentPage';
const ContentPage = LoadableVisibility({
    loader: () => import('../ContentPage'),
    loading: Loading,
});
//import DestinationPage from '../DestinationPage';
const DestinationPage = LoadableVisibility({
    loader: () => import('../DestinationPage'),
    loading: Loading,
});
//import HomePage from '../HomePage';
const HomePage = LoadableVisibility({
    loader: () => import('../HomePage'),
    loading: Loading,
});
//import OrderPage from '../OrderPage';
const OrderPage = LoadableVisibility({
    loader: () => import('../OrderPage'),
    loading: Loading,
});
//import StoriesDestinationPage from '../StoriesDestinationPage';
const StoriesDestinationPage = LoadableVisibility({
    loader: () => import('../StoriesDestinationPage'),
    loading: Loading,
});
//import StoriesPage from '../StoriesPage';
const StoriesPage = LoadableVisibility({
    loader: () => import('../StoriesPage'),
    loading: Loading,
});
//import StoryPage from '../StoryPage';
const StoryPage = LoadableVisibility({
    loader: () => import('../StoryPage'),
    loading: Loading,
});
//import WishListPage from '../WishListPage';
const WishListPage = LoadableVisibility({
    loader: () => import('../WishListPage'),
    loading: Loading,
});
//import VoucherPage from '../VoucherPage';
const VoucherPage = LoadableVisibility({
    loader: () => import('../VoucherPage'),
    loading: Loading,
});
//import PartnersPage from '../PartnersPage';
const PartnersPage = LoadableVisibility({
    loader: () => import('../PartnersPage'),
    loading: Loading,
});
//import PartnersDestinationPage from '../PartnersDestinationPage';
const PartnersDestinationPage = LoadableVisibility({
    loader: () => import('../PartnersDestinationPage'),
    loading: Loading,
});
//import PartnerPage from '../PartnerPage';
const PartnerPage = LoadableVisibility({
    loader: () => import('../PartnerPage'),
    loading: Loading,
});
//import PreviewActivityPage from '../PreviewActivityPage';
const PreviewActivityPage = LoadableVisibility({
    loader: () => import('../PreviewActivityPage'),
    loading: Loading,
});
//import ItineraryPage from '../ItineraryPage';
const ItineraryPage = LoadableVisibility({
    loader: () => import('../ItineraryPage'),
    loading: Loading,
});
//import ReviewAddPage from '../ReviewAddPage';
const ReviewAddPage = LoadableVisibility({
    loader: () => import('../ReviewAddPage'),
    loading: Loading,
});
//import DestinationsPage from '../DestinationsPage';
const DestinationsPage = LoadableVisibility({
    loader: () => import('../DestinationsPage'),
    loading: Loading,
});

function PageContent() {
    return (
        <main>
            <Switch>
                <Route exact path={routes.homePage} component={HomePage} />
                <Route exact path={routes.partnersPage} component={PartnersPage} />
                <Route
                    exact
                    path={routes.partnersDestinationPage}
                    component={PartnersDestinationPage}
                />
                <Route exact path={routes.destinationsPage} component={DestinationsPage} />
                <Route exact path={routes.itineraryPage} component={ItineraryPage} />
                <Route exact path={routes.previewActivityPage} component={PreviewActivityPage} />
                <Route exact path={routes.partnerPage} component={PartnerPage} />
                <Route exact path={routes.cartPage} component={CartPage} />
                <Route exact path={routes.wishList} component={WishListPage} />
                <Route exact path={routes.orderPage} component={OrderPage} />
                <Route exact path={routes.voucherPage} component={VoucherPage} />
                <Route exact path={routes.checkoutPage} component={CheckoutPage} />
                <Route exact path={routes.activityPage} component={ActivityPage} />
                <Route exact path={routes.attractionsPage} component={AttractionsPage} />
                <Route exact path={routes.destinationPage} component={DestinationPage} />
                <Route exact path={routes.blogPostPage} component={BlogPostPage} />
                <Route exact path={routes.storyPage} component={StoryPage} />
                <Route exact path={routes.storiesPage} component={StoriesPage} />
                <Route exact path={routes.blogsPage} component={BlogsPage} />
                <Route
                    exact
                    path={routes.storiesDestinationPage}
                    component={StoriesDestinationPage}
                />
                <Route exact path={routes.blogsDestinationPage} component={BlogsDestinationPage} />
                <Route exact path={routes.activityReviewsPage} component={ActivityReviewsPage} />
                <Route exact path={routes.reviewAddPage} component={ReviewAddPage} />
                <Route exact path={routes.contentPage} component={ContentPage} />
            </Switch>
        </main>
    );
}

export default PageContent;
